import { IsOptional, IsNotEmpty, IsIn, IsNumber, Min } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IDogClass } from "./dog-class.interface";

export class DogClassDto implements IDogClass {
  @IsOptional()
  @IsIn(Object.values(Constants.dog_class_section))
  section?: string;

  @IsNotEmpty()
  @IsIn(Object.values(Constants.dog_class_element))
  show_element: string;

  @IsNotEmpty()
  @IsIn(Object.values(Constants.dog_class_element_level))
  level: string;

  // @IsOptional()
  // @IsNumber()
  // multiplier?: number;

  @IsOptional()
  extra?: string;

  @IsOptional()
  extra_arr?: string[];

  @IsOptional()
  waitlist?: boolean;
  
  @IsOptional()
  time_slot?: string;

  @IsOptional()
  @IsNumber()
  @Min(0)
  fee_override?: number;
}
